<template>
     <div class="sale-content">
        <!-- <NavBar style="z-index:999; postion:relative;"></NavBar> -->
         <img src="../assets/img/bg_1.png" alt="">
        <div class="info-box">
            <div class="info-box-headimg">
                <img src="../assets/img/Rectanglesupper.png" alt="">
            </div>
            <div class="mandy-one">
                <span>{{$t('Congratulations!')}}</span>
                <span>{{$t('You have claimed a free trial lesson')}}</span>
            </div>
            <div class="mandy-two" :class="($t('Congratulations!')!='Congratulations!')?'':'mesersue'">
                <span>{{$t('Our Course Adviser will contact you shortly')}}</span>
            </div>
            <!-- <div class="mandy-icon">
                <img src="../assets/img/avatar.png" alt="" />
                    <h3>{{ info.name }}</h3>
                    <span>{{ info.describe }}</span>
            </div> -->
            <div class="mandy-msg">
                <div class="lo-icon">
                    <img src="../assets/img/message.png" alt="" />
                    <span class="lo-text">{{ info.email }}</span>
                </div>
                <div class="lo-icon">
                    <img class="mobile" src="../assets/img/Calling.png" alt="" />
                    <span class="lo-text ">{{ info.mobile }}</span>
                </div>
                <div class="lo-icon" v-if="$t('Congratulations!')!='Congratulations!'">
                    <img src="../assets/img/WeChat_logo_icon 1.png" alt="" />
                    <span class="lo-text">{{ info.wechat }}</span>
                </div>
            </div>
			<div style="height:30px" v-if="$t('Congratulations!')=='Congratulations!'"></div>
            <div class="m-center">
                <div class="qr-code">
                    <img class="qr-code-1" src="../assets/img/qr-code-1.png" alt="">
                    <img class="qr-code-2" src="../assets/img/qr-code-2.png" alt="">
                    <img class="qr-code-3" src="../assets/img/qr-code-3.png" alt="">
                    <img class="qr-code-4" src="../assets/img/qr-code-4.png" alt="">
                    <img class="qr-code-5"  :src="info.qr_code" alt="" />
                </div>
            </div>
            <div v-if="$t('Congratulations!')!='Congratulations!'" class="mandy-last">请扫码添加课程顾问老师微信</div>
        </div>
		
	</div>
</template>

 <script async src="https://www.googletagmanager.com/gtag/js?id=UA-173502309-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-173502309-1');
</script>

<script>

    import { getStore, keys } from '@/store';
    import '../styles/variable.less'
	export default {
		name: 'salecard',
		data() {
			return {
				info: {
					name: '',
					describe: '',
					email: '',
					mobile: '',
					wechat: '',
					qr_code: '',
				},
                invite_code:'',
			};
		},
		mounted() {
            this.invite_code=this.$route.query.invite_code
            // alert(this.invite_code)
            this.$http.get('/api/getSaleInfo?invite_code='+this.invite_code).then((res) => {
            if (res.data.code == 200) {
                this.info=res.data.data
            }
            })
			// this.info = getStore(keys.user).salesperson_info;
            // console.log(this.info)
			// this.info = user.salesperson_info;
		},
	};
</script>

<style lang="less" scoped>
	.sale-content {
        width:100vw;
        height:100vh;
        position: relative;
		// background-color: #f9f9f9;
		// height: 150px;
		// text-align: center;
        >img{
            width: 557px;
            height: 557px;
            position: absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            // margin-left:-280px;
            // margin-top:-280px;

        }
        .info-box{
            width: 514px;
            // height:666px;
            position: absolute;
            left:50%;
            top:50%;
            // margin-left:-250px;
            // margin-top:-250px;
            transform:translate(-50%,-50%);
            // padding:30px 0;
            background: #FFFFFF;
            border: 0.666332px solid #F2F2F2;
            box-sizing: border-box;
            box-shadow: 0px 6.66332px 26.6533px rgba(0, 0, 0, 0.08);
            border-radius: 6px;
            .info-box-headimg{
                img{
                    width: 100%;
                }
                
            }
            .mandy-one{       
                font-family: 'Sofia Pro Bold';
                font-style: normal;
                font-weight: 700;
                font-size: 28px;
                line-height: 42px;
                text-align: center;
                letter-spacing: -0.02em;
                color: #111827;
                span{
                    display: block;
                    text-align: center;
                }
            }
            .mandy-two{
                font-family: 'Sofia Pro';
                font-style: normal;
                font-weight: 400;
                font-size: 20px;
                line-height: 28px;
                text-align: center;
                font-feature-settings: 'salt' on;
                color: #6B7280;
                margin: 8px 0 37px;
            }
            .mandy-last{
                font-family:  Poppins regular;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 17px;
                text-align: center;
                color: #000000;
                padding: 20px 0 25px;
            }
        }
	}

	.mandy-icon {
		display: flex;
		align-items: center;
        flex-direction: column;
        img{
            width:85px;
            height:85px;
        }
        h3{
            margin:10px 0;
        }
	}
    .mandy-msg{
        width:320px;
        margin:0 auto;
    }
    .lo-icon{
		display: flex;
		align-items: center;
        margin:25px;
        img{
            width:20px;
            height:20px;
            margin-right:27px;
        }
        &:first-child img{
            width:18px;
            height:17px;
        }
        &:last-child img{
            width:20px;
            height:20px;
        }
        .mobile{
            width:22px !important;
            height:22px !important;
             margin-right:25px;
        }
        span{
            display: inline-block;
            width: 100%;
            word-break: break-word;
            font-family: Poppins;
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 17px;
            color: #0B1D33;

        }
    }
	.qr-code {
		height: 165px;
		width: 180px;
        display: flex;
        justify-content: center;
        align-items: center;
		line-height: 100px;
		// background: #4b69fe;
		border-radius: 4px;
		margin: 33px auto 21px;
		text-align: center;
        position: relative;
         .qr-code-1, .qr-code-2, .qr-code-3, .qr-code-4{
            width: 20px;
            height: 20px;
         }
        .qr-code-1{
            position: absolute;
            top: 0;
            left: 0;
        }
         .qr-code-2{
            position: absolute;
            top: 0;
            right: 0;
        }
         .qr-code-3{
            position: absolute;
            bottom: 0;
            left: 0;
        }
         .qr-code-4{
            position: absolute;
            bottom: 0;
            right: 0;
        }
         .qr-code-5{
            // position: absolute;
            // top: 0;
            // left: 0;
            width: 146px;
            height: 146px;
        }
		img {
			width: 95px;
			height: 95px;
			vertical-align: middle;
		}
	}
</style>

<style lang="less" scoped>
    @device:763px;
	@media screen and (min-width: @device) {
	
		
	}

	@media screen and (max-width: @device) {

        .sale-content {
            width: 100vw;
            height: 100vh;
            position: relative;
            >img{
                width: calc(100vw - 30px);
                height: calc(100vw - 30px);
                margin:0 auto;
                position:absolute;
                transform:translate(-50%,-50%);
                // top: 100px;
                // left: 30px;

            }
            .info-box{
                width: calc(100vw - 65px);
                height:initial;
                position:absolute;
                // top:120px;
                // left:50px;
                // margin-left:0;
                // margin-top:0;
                transform:translate(-50%,-50%);
                // padding:20px 0;
                background: #FFFFFF;
                border: 0.666332px solid #F2F2F2;
                box-sizing: border-box;
                box-shadow: 0px 6.66332px 26.6533px rgba(0, 0, 0, 0.08);
                border-radius: 6px;
                .info-box-headimg{
                    img{
                        width: 100%;
                    }
                }
                .mandy-one{       
                    font-family: 'Sofia Pro Bold';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 22px;
                    text-align: center;
                    letter-spacing: -0.02em;
                    color: #111827;
                    margin: 19px 0 8px;
                    span{
                        display: block;
                        text-align: center;
                    }
                }
                .mandy-two{
                    font-family: 'Sofia Pro';
                    font-style: normal;
                    font-weight: 400;
                   font-size: 12px;
                    line-height: 20px;
                    text-align: center;
                    font-feature-settings: 'salt' on;
                    color: #6B7280;
                    margin: 8px 0 12px;
					width: 200px;
					margin: 0 auto;
                }
                .mandy-last{
                    font-family:  Poppins regular;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 17px;
                    text-align: center;
                    color: #000000;
                    padding: 20px 0 25px;
                }
            }
        }
         .lo-icon{
		display: flex;
		align-items: center;
        margin:18px;
        img{
            width:19px;
            height:19px;
            margin-right:20px;
        }
        &:first-child img{
            width:17px;
            height:17px;
        }
        &:last-child img{
            width:19px;
            height:19px;
        }
        .mobile{
            width:22px !important;
            height:22px !important;
            margin-right:18px;
        }
        span{
            display: inline-block;
            width: 100%;
            word-break: break-word;
            font-family: Poppins;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 17px;
            color: #0B1D33;

        }
        }
        .qr-code {
            height: 125px;
            width: 140px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 100px;
            // background: #4b69fe;
            border-radius: 4px;
            margin: 15px auto 10px;
            text-align: center;
            position: relative;
            .qr-code-1, .qr-code-2, .qr-code-3, .qr-code-4{
                width: 15px;
                height: 15px;
            }
            .qr-code-1{
                position: absolute;
                top: 0;
                left: 0;
            }
            .qr-code-2{
                position: absolute;
                top: 0;
                right: 0;
            }
            .qr-code-3{
                position: absolute;
                bottom: 0;
                left: 0;
            }
            .qr-code-4{
                position: absolute;
                bottom: 0;
                right: 0;
            }
            .qr-code-5{
                // position: absolute;
                // top: 0;
                // left: 0;
                width: 106px;
                height: 106px;
            }
            // img {
            // 	width: 95px;
            // 	height: 95px;
            // 	vertical-align: middle;
            // }
        }
        .mandy-msg{
            width:280px;
            margin:0 auto;
        }
		.mesersue{
			width: 190px !important;
            margin: 0 auto 44px !important;
		}
    }
</style>


// WEBPACK FOOTER //
// src/components/salecard.vue